/**
* @author vishwadeep.kapoor
* VideoIframe
* @see /client/containers/HomePage/SegmentCarousel.js
*/

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const VideoIframe = styled.div`
`;

function videoIframe(props) {
  const { video, height } = props;
  return (
    <VideoIframe>
      <iframe
        title="youtube"
        width="100%"
        height={height}
        src={`${video}?autoplay=1`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </VideoIframe>
  );
}

videoIframe.propTypes = {
  video: PropTypes.string,
  height: PropTypes.string,
};

export default videoIframe;



// WEBPACK FOOTER //
// client/components/VideoCard/VideoIframe.js